import axios from 'axios';
import http from './http';
import { apiQRcode } from '@/config';

// 获取 DMS 埋点配置文件
export const fetchTelescopeCode = () => {
  return axios.get('https://static.91jkys.com/dms/f5ae3776977740287aa19af0ab7725e4.json').then(res => {
    return res.data;
  });
};

/*
  获取邀请者播报列表
  @see http://mock.qa.91jkys.com/project/180?moduleId=838&interfaseId=6442
*/
export const inviteAwardBroadcast = params => {
  const url = '/inviter_customer_api/1.0/inviteAwardBroadcast';
  return http({
    url,
    method: 'Get',
    params
  });
};

/*
  获取邀请者活动主页信息
  @see http://mock.qa.91jkys.com/project/180?moduleId=838&interfaseId=6518
*/
export const queryInviterActivityHome = params => {
  const url = '/inviter_customer_api/1.0/queryInviterActivityHome';
  return http({
    url,
    method: 'Get',
    params
  });
};

/*
  获取邀请者奖励记录汇总
  @see http://mock.qa.91jkys.com/project/180?moduleId=838&interfaseId=6449
*/
export const inviteAwardTotalDetail = params => {
  const url = '/inviter_customer_api/1.0/inviteAwardTotalDetail';
  return http({
    url,
    method: 'Get',
    params
  });
};

/*
  获取小程序二维码
  @see http://mock.qa.91jkys.com/project/159?moduleId=848&interfaseId=6375
*/
export const unlimitedQrCode = params => {
  const url = apiQRcode + 'composite_wechat/1.0.0/unlimitedQrCode';
  return http({
    url,
    method: 'post',
    params
  });
};

export const inviteAwardTotalDetailGet = params => {
  const url = '/inviter_customer_api/1.0/inviteAwardTotalDetail';
  return http({
    url,
    method: 'Get',
    params
  });
};

export const inviteAwardRecordGet = params => {
  const url = 'inviter_customer_api/1.0/inviteAwardRecord';
  return http({
    url,
    method: 'Get',
    params
  });
};
